import { PrintDeadItemTBodyLayout, PrintDeadItemTHeadLayout, PrintSectionLayout } from "../../layout";

type Item = {
	name: string;
	canceledPrice: number;
};

type Props = {
	items: Array<Item>;
};

export const DeadItemsOfPrintComposition = ({ items }: Props) => {
	return (
		<PrintSectionLayout titleChildren={<p className="text-sm font-bold">その他キャンセル</p>}>
			<div>
				<PrintDeadItemTHeadLayout />

				{items.map((item, index) => {
					const { name, canceledPrice } = item;

					return <PrintDeadItemTBodyLayout key={index} name={name} canceledPrice={canceledPrice} />;
				})}
			</div>
		</PrintSectionLayout>
	);
};
